import * as React from "react"

function Twitter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={31.001}
      height={31.001}
      viewBox="0 0 31.001 31.001"
      {...props}
    >
      <path d="M15.501 0a15.5 15.5 0 1015.5 15.5A15.5 15.5 0 0015.501 0zm7.808 12.376c.008.167.011.336.011.505a11.11 11.11 0 01-17.1 9.36 7.989 7.989 0 00.932.054 7.837 7.837 0 004.851-1.672 3.912 3.912 0 01-3.649-2.714 3.815 3.815 0 00.735.07 3.882 3.882 0 001.028-.136 3.909 3.909 0 01-3.134-3.83v-.05a3.893 3.893 0 001.77.489 3.911 3.911 0 01-1.209-5.216 11.09 11.09 0 008.052 4.081 3.909 3.909 0 016.656-3.563 7.8 7.8 0 002.481-.948 3.918 3.918 0 01-1.719 2.161 7.81 7.81 0 002.244-.615 7.892 7.892 0 01-1.949 2.024z" />
    </svg>
  )
}

export default Twitter